module.exports = __webpack_public_path__ + "static/ally-URI-eb1a3e6df1b09b2dc9ea6cbf0846c132.png";